import { Box, Tab, Tabs } from "@mui/material";
import React, { Suspense, useId, useState } from "react";

const labels = ["Core", "Skills/Tools", "Analysis", "Advanced"];

// Keep tab selection local: switching panels must not re-render the settings
// form or remount hundreds of tool controls. Unvisited panels remain lazy.
export function KBoSettingsTabs({
    children,
    resetKey,
}: {
    children: React.ReactNode[];
    resetKey: number;
}) {
    const [activeTab, setActiveTab] = useState(0);
    const [visited, setVisited] = useState([0]);
    const id = useId();
    return (
        <>
            <Tabs
                value={activeTab}
                onChange={(_, next: number) => {
                    setActiveTab(next);
                    setVisited((previous) =>
                        previous.includes(next)
                            ? previous
                            : [...previous, next],
                    );
                }}
                sx={{ mb: 2, borderBottom: 1, borderColor: "divider" }}
            >
                {labels.map((label, index) => (
                    <Tab
                        key={label}
                        label={label}
                        id={`${id}-tab-${index}`}
                        aria-controls={`${id}-panel-${index}`}
                    />
                ))}
            </Tabs>
            {children.map((child, index) => (
                <Box
                    key={`${resetKey}-${index}`}
                    role="tabpanel"
                    id={`${id}-panel-${index}`}
                    aria-labelledby={`${id}-tab-${index}`}
                    hidden={activeTab !== index}
                >
                    {visited.includes(index) && (
                        <Suspense
                            fallback={
                                <Box role="status">Loading settings…</Box>
                            }
                        >
                            {child}
                        </Suspense>
                    )}
                </Box>
            ))}
        </>
    );
}
